import script from "./ActivityDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./ActivityDetailDialog.vue?vue&type=style&index=0&id=946e6c30&scoped=true&lang=css"
import "./ActivityDetailDialog.vue?vue&type=style&index=1&id=946e6c30&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-946e6c30"]])

export default __exports__